export default __webpack_public_path__ + "static/media/group_login_bg.f4bd9d06.png";